exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drop-toggle {\n  background-color: #fff;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  cursor: hand;\n  border: 1px solid #ccc;\n  width: 100%;\n  text-align: left;\n  height: 35px; }\n\n.drop-toggle i {\n  float: right; }\n\n/*.drop-toggle span {\r\n  max-width: 99%;\r\n}*/\n.drop-show {\n  padding: 4px 5px;\n  min-width: 10%;\n  background-color: #FFF;\n  border: 1px solid blue;\n  position: absolute;\n  z-index: 999 !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n  margin-left: 0px; }\n\n.drop-show label {\n  display: block;\n  font-size: 10px;\n  cursor: pointer; }\n\n.drop-show label input {\n  vertical-align: top; }\n\n.drop-show label span {\n  display: inline-block; }\n\n.require-input-1 {\n  border-left: 3px solid #dc3545;\n  margin-bottom: 10px; }\n\n.require-input-2 {\n  border-left: 3px solid #28a745;\n  margin-bottom: 10px; }\n\n.replas-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/multi-dropdown-import/multi-dropdown-import.component.scss
// module id = 2036
// module chunks = 66